export default {
    slug: 'store'
};
